export default "__VITE_ASSET__BqSVcv6n__"